import { Loader } from '@neo.tax/shared';

import { useSredHomeRedirect } from './hooks';
import { SredHomeLayout } from './organisms';

export const SredHome = (): React.ReactElement => (
  <Loader useRedirect={useSredHomeRedirect}>
    <SredHomeLayout />
  </Loader>
);
